<template>
    <div class="wrapper" v-bind:class="{'collapsed': collapsedSidebar}">
        <sidebar></sidebar>
        <div class="main">
            <topbar @closeSidebar="toggleSidebar"></topbar>
            <router-view/>

        </div>
        <div class="create-post-fixed" id="create-post-button" v-bind:class="{'visible': scrolled}">
            <svgicon name="create" />
        </div>
        <ToastWrapper :toastlist="ToastList"/>
    </div>
</template>
<script>
    import Topbar from "@/components/Navigation/Topbar";
    import Sidebar from "@/components/Navigation/Sidebar/Sidebar";
    import ToastWrapper from "../../../components/ToastWrapper/ToastWrapper"

    export default {
        name: 'Wrapper',
        components: {
            Sidebar,
            Topbar,
            ToastWrapper
        },
        props: [],
        data () {
            return {
                collapsedSidebar: false,
                ToastList: [
                    // {
                    //     variant: 'good',
                    //     text: 'Welcome Back, Stijn!'
                    // },
                    // {
                    //     variant: 'default',
                    //     text: 'User added successfully'
                    // }
                ],
                scrolled: false
            }
        },
        computed: {

        },
        mounted () {

        },
        methods: {
            toggleSidebar: function(){
                this.collapsedSidebar = !this.collapsedSidebar;
            },
            handleScroll (event) {
                this.checkScroll();
            },
            checkScroll: function() {
                if (window.scrollY > 70) {
                    this.scrolled = true;
                } else {

                    this.scrolled = false;
                }
            }
        },
        created () {
            window.addEventListener('scroll', this.handleScroll);
            this.checkScroll();
        },
        destroyed () {
            window.removeEventListener('scroll', this.handleScroll);
        }
    }
</script>
<style src="./Wrapper.scss" scoped lang="scss"></style>

